import React from 'react';
import Icon from './Icon';

/**
 * FeatureIcon Premium V2 - Senior UI Engineer & Visual Designer Edition
 * - 40% Larger Visual Presence
 * - Premium Glass-Orb Container
 * - Cinematic Idle Glow Pulse
 * - Buoyant Hover Lift & Interaction
 */
const FeatureIcon = ({ name, size = "md", priority = "secondary", className = "" }) => {
    // Priority-specific Glow/Gradients
    const glowColors = {
        hero: "bg-blue-500/30 group-hover:bg-blue-400/50 shadow-[0_0_50px_rgba(37,99,235,0.6)]",
        primary: "bg-cyan-500/20 group-hover:bg-cyan-400/40 shadow-[0_0_35px_rgba(6,182,212,0.4)]",
        secondary: "bg-indigo-500/10 group-hover:bg-indigo-400/30 shadow-[0_0_20px_rgba(99,102,241,0.2)]",
        supporting: "bg-slate-500/5 group-hover:bg-slate-400/20 shadow-none"
    };

    // 40% Larger scale compared to V1
    const sizeClasses = {
        sm: "w-14 h-14 p-3",      // was 10
        md: "w-20 h-20 p-4",      // was 14
        lg: "w-28 h-28 p-6",      // was 20
        xl: "w-36 h-36 p-8"       // was 24
    };

    const iconSizes = {
        sm: 28,
        md: 45,
        lg: 68,
        xl: 80
    };

    // Significant Hover Interaction
    const getHoverEffect = () => {
        const effects = {
            rocket: "group-hover:-translate-y-5 group-hover:-rotate-12 group-hover:scale-110",
            sparkles: "group-hover:-translate-y-4 group-hover:rotate-45 group-hover:scale-125",
            target: "group-hover:-translate-y-4 group-hover:scale-115",
            ai: "group-hover:-translate-y-4 group-hover:rotate-6 group-hover:scale-110",
        };
        return effects[name] || "group-hover:-translate-y-4 group-hover:rotate-3 group-hover:scale-110";
    };

    return (
        <div className={`
            relative flex items-center justify-center
            rounded-full
            bg-gradient-to-tr from-white/20 to-white/5
            backdrop-blur-xl
            border-2 border-white/30
            transition-all duration-700 cubic-bezier(0.34, 1.56, 0.64, 1)
            group cursor-pointer
            ${sizeClasses[size] || sizeClasses.md}
            ${glowColors[priority]}
            ${priority === 'hero' ? 'animate-pulse-glow' : ''}
            ${className}
`}>
            {/* Cinematic Halo Effect (Visible Layer) */}
            <div className={`
                absolute inset-0 rounded-full blur-3xl -z-10
                transition-all duration-700
                ${priority === 'hero' ? 'bg-blue-400/40 opacity-100' : 'bg-white/10 opacity-0 group-hover:opacity-100'}
`} />

            {/* Inner Depth Shadow */}
            <div className="absolute inset-2 rounded-full shadow-inner bg-white/5 -z-10" />

            <Icon
                name={name}
                size={iconSizes[size] || iconSizes.md}
                className={`
text-white drop-shadow-[0_10px_10px_rgba(0,0,0,0.3)]
transition-all duration-700
                    ${getHoverEffect()}
`}
            />
        </div>
    );
};

export default FeatureIcon;
